const initLazyLoad = () => {
  const windowHeight: number =
    window.innerHeight || document.documentElement.clientHeight;

  const lazyload = () => {
    const images = [...document.querySelectorAll('.lazy')];

    images.forEach(function (img: HTMLImageElement, i) {
      const { top, height } = img.getBoundingClientRect();

      const load = (): void => {
        if (img.dataset?.src) img.src = img.dataset.src;
        if (img.dataset?.srcset) img.srcset = img.dataset.srcset;
        if (img.hasAttribute('img-load')) img.setAttribute('img-load', 'true');
        if (img.dataset?.bgSrc) img.setAttribute('style', img.dataset.bgSrc);

        img.classList.remove('lazy');
      };

      if (top > 0 && top < windowHeight) {
        load();
      } else if (top < windowHeight + height) {
        load();
      } else if (
        top > windowHeight + height &&
        top < windowHeight + 2 * height
      ) {
        load();
      }
    });

    if (images.length == 0) {
      window.removeEventListener('scroll', lazyload);
    }
  };

  window.addEventListener('scroll', lazyload);
};

export default initLazyLoad;
